import { Box as MUIBox } from '@mui/material'
import { node, string } from 'prop-types'

// For a full list of available props, see: https://v5.mui.com/system/properties/
const Box = ({ children, component = 'div', ...props }) => (
  <MUIBox component={component} {...props}>
    {children}
  </MUIBox>
)

export default Box

Box.propTypes = {
  children: node.isRequired,
  component: string,
}
